<template>
     <div class="shop">
        <section class="title_box" v-if="$store.state.common.theme!=3">
            <h2 class="title_left">{{items.title}}</h2>
            <router-link tag="span" class="title_right" to="/meetingRoom">更多</router-link>
            </section>
        <section v-if="$store.state.common.theme==3" class="title_box_theme3">
            <h2 class="title_left">{{items.title}}</h2>
            <router-link tag="span" class="title_right" to="/meetingRoom">更多</router-link>
        </section>
        <!-- 一行1个 -->
        <div v-if="items.listStyle == 1" class="shop_list">
            <div  class="list_item"
                @click="toRoomDetail(item)"
                v-for="(item,index) in newList"
                :key="index">
                <div class="list_item_top">
                   
                    <img class="img_box" :src="item.meetingRoomImages?item.meetingRoomImages:require(`../../../assets/images/img_company_wall.jpg`)"/>
                   
                    <div class="list_item_top_right">
                        <span class="center_right_title">{{item.meetingRoomName}}</span>
                        <span class="center_right_area">面积{{item.area}}㎡ 座位{{item.meetingRoomNum}}人</span>
                        <span class="center_right_address">{{item.address}}</span>
                        <span class="price">
                        <span>￥{{item.unitPrice | priceT}}</span> / 小时起</span>
                    </div>
                </div>
                <!-- v-if="item.isOnlinePay" -->
                <div class="list_box_bottom" >
                    <div class="scale_box">
                        <div class="scale_item" v-for="(mess,index) in item.amData" :key="index">
                        <span class="number">{{index%2==0?index/2:''}}</span>
                        <div :class="['scale_item_bottom',index == 24?'scale_item_bottom_no':'']">
                            <span v-if="index%2==0" :class="['line_h',index==24?'line_h_last':'']"></span>
                            <span v-if="index != 24" :class="['block',mess==1?'':'white']"></span>
                            <span v-if="index%2==0 && index != 24" class="line"></span>
                        </div>
                        </div>
                        <span class="time_am">AM</span>
                    </div>
                    <div class="scale_box">
                        <span class="time_am time_pm">PM</span>
                        <div class="scale_item" v-for="(mess,index) in item.pmData" :key="index">
                        <span class="number">{{index%2==0?index/2+12:''}}</span>
                        <div :class="['scale_item_bottom',index == 24?'scale_item_bottom_no':'']">
                            <span v-if="index%2==0" :class="['line_h',index==24?'line_h_last':'']"></span>
                            <span v-if="index != 24" :class="['block',mess==1?'':'white']"></span>
                            <span v-if="index%2==0 && index != 24" class="line"></span>
                        </div>
                        </div>
                    </div>
                </div>
            
            </div>


        </div>
        
         <!-- 横向滚动 -->
        <div class="scroll" ref="gun"   v-else-if="items.listStyle == 2" >
            <ul ref="nav" class="shop_list_scroll">
                 <router-link
                    ref="personTab"
                    tag="li"
                    class="list_item"
                    v-for="(item,index) in newList"
                    :key="index"
                     :to="'/roomDetail?id='+item.id"
                >
                    <div class="img_box">
                        <img :src="item.meetingRoomImages?item.meetingRoomImages:require(`../../../assets/images/img_company_wall.jpg`)"/>
                    </div>
                    <p class="list_item_p">{{item.meetingRoomName}}</p>
                    <p class="list_item_p list_item_address">面积{{item.area}}㎡ 座位{{item.meetingRoomNum}}人</p>
                    <p class="list_item_p list_item_address">{{item.address}}</p>
                    <p class="list_item_p list_item_price"><span style="color:red">￥{{item.unitPrice}}</span>/ 小时起</p>
                </router-link>
            </ul>
        </div>
      <!-- 一行2个 -->
       <ul class="shop_list_two" v-else-if="items.listStyle == 0" >
            <router-link
                tag="li"
                :to="'/roomDetail?id='+item.id"
                class="list_item_two"
                v-for="(item,index) in newList"
                :key="index"
            >
                <div class="img_box">
                    <img :src="item.meetingRoomImages?item.meetingRoomImages:require(`../../../assets/images/img_company_wall.jpg`)"/>
                </div>
                <p class="list_item_p">{{item.meetingRoomName}}</p>
                <p class="list_item_p list_item_address">面积{{item.area}}㎡ 座位{{item.meetingRoomNum}}人</p>
                <p class="list_item_p list_item_address">{{item.address}}</p>
                <p class="list_item_p list_item_price"><span style="color:red">￥{{item.unitPrice}}</span>/ 小时起</p>
            </router-link>
        </ul>

    </div>
  
  
 
</template>

<script>
import { mapState, mapActions } from "vuex";
import BScroll from "better-scroll";
import util from "../../../utils/util";
export default {
  name: "indexMeeting",
  components: {},
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    items: {
      type: Object,
      default() {
        return {
          listStyle:0
        }

      }
    }
  },
  data() {
    return {};
  },
  computed: {
    newList() {
        let newList = this.list;
    //   if(this.$store.state.common.theme!=3){
        if (this.items.listStyle === 1) {  //1行一个
           
          return newList.slice(0, 2);
        } else if (this.items.listStyle === 2) { //横向滚动
          return newList.slice(0, 8);
        } else if (this.items.listStyle === 0) { //1行两个
          return newList.slice(0, 4);
        } else {
          return newList ;
        }
    //   }else{
    //     return newList.slice(0, 3);
    //   }
    },

  },

  created() {
    if (this.items.listStyle == 2) {
      setTimeout(() => {
        this.tabScroll();
      }, 2000);
    }
  },
  methods: {
    toRoomDetail(item){
      this.$router.push('/roomDetail?id='+item.id);
    },
     tabScroll() {
      if (!this.scroll) {
        this.$refs.nav.style.width =
          (this.$refs.personTab[0].$el.clientWidth +10)*
            this.$refs.personTab.length +
          "px";
        this.scroll = new BScroll(this.$refs.gun, {
          startX: 0,
          click: true,
          scrollX: true,
          // 忽略竖直方向的滚动
          scrollY: false,
          eventPassthrough: "vertical"
        });
      } else {
        this.scroll.refresh();
      }
    }
  }
  
 
 
};
</script>
<!--  background-color: #fff; -->
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.wrapper {
  width: 100%;
}
.shop {
  margin-top:10px;
  padding-left:28px;
  padding-right: 28px;
  width: 694px;
  min-width: 694px;
  overflow: hidden;
  padding-top:20px;
  .title_box {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: 1rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .title_right {
      font-size: 0.26rem;
      color: #666;
    }
  }
  .title_box_theme3 {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: .44rem;
    margin-bottom: 0.26rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size:40px;
      line-height: 44px;
      font-weight: bold;
      color: #000000;
      padding-right: 0.56rem;
      background: url("../../../assets/images/icon_hot_3.png") right center
        no-repeat;
      background-size: 44px 44px;
    }
    .title_right {
      font-size: 0.26rem;
      color: #c9a779;
    }
  }
}
.shop_list {
  .flex();
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 684px;
    .border();
    background-color: #ffffff;
    overflow: hidden;
    box-sizing:border-box;
    margin-bottom: 20px;
   
    padding: 28px;
    .list_item_top{
        flex-direction: row;
        width: 100%;
        display: flex;
        .img_box{
            width: 216px;
            height: 162px;
            margin-right: 28px;
            background: #d8d8d8;
           
        }
        .list_item_top_right{
            display: flex;
            flex-direction: column;
            flex: 1;
            justify-content: space-between;
             .center_right_title {
                width: 410px;
                height: 40px;
                font-size: 28px;
                color: rgba(51, 51, 51, 1);
                font-weight: bold;
                line-height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 8px;
            }

            .center_right_area,
            .center_right_address {
                height: 28px;
                font-size: 24px;
                color: rgba(153, 153, 153, 1);
                line-height: 28px;
                margin-bottom: 8px;
            }

            .center_right_address {
                width: 410px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .price {
                height: 40px;
                font-size: 24px;
                color: rgba(51, 51, 51, 1);
                line-height: 40px;
            }

            .price span {
                font-size: 28px;
                color: #fc3f56;
            }

        }
       

    }
    
   
  }
  
}
.shop_list_two{
     .flex();
    justify-content: space-between;
    .list_item_two {
        width: 344px;
        flex-direction: column;
        .border();
        margin-right: 0px;
        background-color: #ffffff;
        overflow: hidden;
        box-sizing:border-box;
        border-radius: 6px;
        margin-bottom: 20px;
        box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
        align-items: flex-start;
        .img_box{
            width: 100%;
            width: 344px;
            height: 228px;
            display:flex;
            flex-direction:row;
            border:0;
            img {
                display: block;
                width: 344px;
                height: 228px;     
            }
        }
        p {
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
            text-align:left;
            font-size:26px;
            line-height:34px;
            .textOver(300px);
        }
        .list_item_address{
            font-size:24px;
            color:rgba(153,153,153,1);
            line-height:34px;
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
            font-weight:normal;
        }
        .list_item_price{
             line-height:34px;
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
            font-size:24px;
            font-weight:normal;
            margin-bottom: 10px

        }
    }

}

.shop_list_theme3{
  .flex();
  border-radius: 10px;
  flex-direction: row;
  background-color: #ffffff;
  padding-bottom: 20px;
  padding-top: 20px;
  .list_item{
    .flex();
    margin-right: 30px;
    margin-left: 10px;
    width: 200px;
    flex-direction: column;
   
  }
  .last_item{
    margin-right: 0;
    margin-left: 10px;
    .flex();
    width: 200px;
    flex-direction: column;
   
    
  }
  .list_item_icon{
    width: 200px;
    height: 200px;
  }
  .list_item_title{
    width: 200px;
    .flex();
    margin-top: 10px;
    flex-direction: row;
    justify-content: center;
    
    p{
        .fontSize(13px);
        font-weight: bold;
        color:#000000;
        line-height: 34px;
    
        .textOver(200px);
    }
  }

}

.scroll{
  max-width: 694px;
}

.shop_list_scroll {
  flex-direction: row;
    overflow-x: scroll;
   -webkit-overflow-scrolling: auto;
    white-space: nowrap;
   flex-wrap: nowrap;
  .list_item {
    flex-shrink: 0;
    width: 280px;
    display: inline-block;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;
    margin-right: 20px;
    .border();
    box-sizing:border-box;
    background-color: #ffffff;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
    .img_box{
      display:flex;
      flex-direction:row;
      img {
        display: block;
        width: 280px;
        height: 160px;
      }
    }
    .list_item_p {
      margin-top:10px;
      margin-left: 10px;
      .fontSize(12px);
      font-weight: bold;
      color: @color3;
      line-height: 34px;
      text-align: left;
      width:240px;
      .textOver(240px);
    }
    .list_item_address{
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
       margin-left: 10px;
       margin-right: 10px;
       margin-top: 10px;
      font-weight:normal;
    }
    .list_item_price{
          line-height:34px;
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
            font-size:24px;
            font-weight:normal;
            margin-bottom: 10px
        
    }
  }
}

/* 时间轴 */
.list_box_bottom {
  height: 164px;
  padding: 28px 0 8px;
}
.scale_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 68px;
  padding-left: 8px;
  margin-bottom: 14px;
  overflow: visible;
}
.scale_item {
  height: 68px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: visible;
}
.number {
  display: block;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
  margin-left: -5px;
}
.scale_item_bottom {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  border-bottom: 2.1px solid #dadada;
  box-sizing: border-box;
}
.scale_item_bottom_no {
  border-bottom: 2.1px solid #fff;
}
.line_h {
  height: 30px;
  width: 2px;
  background: #dadada;
}
.line_h_last {
  margin-bottom: -2px;
  height: 32px;
}
.block {
  width: 22px;
  height: 18px;
  background: #dadada;
}
.white {
  background: #fff;
}
.line {
  width: 2px;
  height: 18px;
  background: #dadada;
}
.time_am {
  height: 68px;
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  line-height: 100px;
  flex: 1;
  text-align: right;
}
.time_pm {
  text-align: left;
}

</style>
